import { Map, fromJS } from 'immutable';

export function request(state, { id }) {
    return state.setIn([ 'items', id, 'resulting' ], Map({
        state: 'IN_PROGRESS'
    }));
}

export function error(state, { id, errors }) {
    return state.setIn([ 'items', id, 'resulting' ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));
}

export function finish(state, { id }) {
    return state
        .setIn([ 'items', id, 'resulting' ], Map({
            state: 'FINISHED'
        }));
}
